$(function() {
  //モバイルメニュー表示
   	$('.logo-area .logo-area__right .mobile-nav-toggle').click(function(){
      $('body').addClass("enable-mobile-nav-transition reveal-mobile-nav reveal-mobile-nav--revealed is-fixed");
      return false;
    });	
  
	//アコーディオン
	$('.section-footer__menu-block .section-footer__title').click(function(){
		if (window.matchMedia( "(max-width: 767px)" ).matches) {
			$(this).toggleClass("is-open");
			$(this).next('.section-footer__menu-block__menu').slideToggle();
		}
	});	
  
  //フィルター内クリックしたらドロワー閉じる
    $('body').on('click', '.filter-container .filter-group__item, .filter-container .filter-toggle__input-label, #filters_close_btn', function() {
      if (window.matchMedia( "(max-width: 767px)" ).matches) {
		$('.filter-container.filter-container--side').removeClass("filter-container--show-filters-desktop");
        $('.filter-container.filter-container--side').removeClass("filter-container--show-filters-mobile");
      }
	});
  //SPメニュー内タブ切り替え
  $('.menu_tab_navi span').click(function(){
    $('.menu_tab_navi span').removeClass("is-current");  
    $(this).addClass("is-current");
    var tab = $(this).data("link");
    $('.tab_content').hide();  
    $(tab).fadeIn();  
    
  });
    $('body').on('click', '.navigation__item:not(.navigation__item--with-mega-menu) .navigation__link', function() {
        const url = $(this).attr('href');
        window.location.href = url;
	});

  //もっと見る
  $('.more-cnt').each(function () {
      const $content = $(this);

      // ラッパーを作成
      $content.wrap('<div class="more-wrap"></div>');

      // ボタンを追加
      const $btn = $('<div class="more-btn">More</div>');
      $content.after($btn);

      // 長さ判定してボタン表示
      if ($content[0].scrollHeight > $content.innerHeight()) {
        $btn.show();
      }

      // ボタンのクリックイベント
      $btn.on('click', function () {
        $content.toggleClass('expanded');
        $(this).text($content.hasClass('expanded') ? 'Close' : 'More');
      });
    });
  
  //メニュー内のスライド  
  
  const mySwiper = new Swiper('.menu_slider .swiper', {
    slidesPerView: 1,
    grabCursor: true,
    navigation: {
      nextEl: '.menu_slider .swiper-button-next',
      prevEl: '.menu_slider .swiper-button-prev',
    }
  });
})
